export const imageConstants = {
    eventImageCropRatio: 1.913,
    productImageAspectRatio: 0.75,
    assetCardCropRatio: 1.42,
    squareAspectRatio: 1,
    bookingCardCropRatio: 1.333,
    MAX_IMAGE_BYTES: 7_500_000,

}
